export const dismissElement = (className) => {
  document.getElementsByTagName(className).forEach((element) => {
    element.dismiss()
  })
}
